/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form} from 'antd';
import {Button, layout} from 'icsoc-antd-ex';
import TaskProgress from 'Components/taskProgress';
// import {translateObjToString} from 'Utils';

import './index.less';

const {BaseContentMainHeader} = layout;
const FormItem = Form.Item;

class Header extends Component {
  // 导出
  export = () => {
    const {setReloadModalVisible} = this.props;
    setReloadModalVisible();
  };

  // 重呼
  reCall = () => {
    const {setReCallModalVisible} = this.props;
    setReCallModalVisible();
  };

  render() {
    const {login} = this.props;
    return (
      <BaseContentMainHeader title="任务详情">
        <Form layout="inline">
          {
            login.permissionsList.includes('taskManageDetail.export') ?
            <FormItem>
              <Button type="primary" onClick={() => this.export()}>
                导出
              </Button>
            </FormItem>
          : null}
          {/* {
            login.permissionsList.includes('taskManageDetail.recall') ?
            <FormItem>
              <Button onClick={() => this.reCall()}>一键重呼</Button>
            </FormItem>
          : null} */}
          <FormItem>
            <TaskProgress />
          </FormItem>
        </Form>
      </BaseContentMainHeader>
    );
  }
}

const mapStateToProps = ({taskManageDetail,login}) => ({
  tableListData: taskManageDetail.tableListData,
  login
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
